(function(){
  angular
      .module('appback')
      .directive('ngSelect2hoja', select2hoja);

      select2hoja.$inject = ['$timeout'];
      function select2hoja($timeout){
          return {
            require: 'ngModel',
            scope:{
              ngModel:"=",
              options:"=",
              extraparams : "=",
              removesearcher : "=",
              diasacaducar : "="
            },
          link: function (scope, element, $attrs, ngModel) {
            return $timeout(function () {
                // console.log("name",$attrs.name);
                // console.log("select2hoja ",$attrs.name);
              var options = {};
              if(scope.options){
                options = angular.copy(scope.options);
                if(scope.extraparams){
                  var datavar = options.ajax.data({});
                  options.ajax.data = function(params){
                    datavar.q = params.term;
                    datavar.page = params.page;
                    if($attrs.campos){
                      datavar.field = $attrs.campos;
                    }
                    var objectMerge = angular.merge({}, datavar, scope.extraparams);
                    return objectMerge;
                  }
                }
              }
              var $element = $(element);
              // console.log($element.length)
              if(scope.removesearcher===true){
                options.minimumResultsForSearch = -1;
              }
              $element.select2(options);
               $element.on("change.select2", function (evt) {
                  // console.log("select2:select1");
                  evt.stopPropagation();
               });
              $element.on("select2:open", function (evt) {
                  $timeout(function(){
                      document.querySelector('.select2-search__field').focus();
                  });

                  //self.$search.attr('tabindex', 0);
                  //self.$search.focus(); remove this line
                  //setTimeout(function () { self.$search.focus(); }, 10);//add this line

              });
               $element.on("change", function (evt) {
                // console.log("changesingle");
                evt.stopPropagation();
               })
              $element.on("select2:select", function (evt) {
                // console.log("select2:select ", typeof $element.val());
                var elemntoCombo = $element.val();
                if(ngModel.$viewValue == elemntoCombo){
                  return true;
                }
                  if(!isNaN(elemntoCombo)){
                    elemntoCombo = elemntoCombo.toString();
                  }
                  $timeout(function(){
                    // console.log('set esto', elemntoCombo)
                    ngModel.$setViewValue(elemntoCombo) ;
                  });
                  
                  // var elementVar = evt.params.data.element;
                  // var $elementVar = $(elementVar);
                  // console.log($element.val());
                  
                  // console.log(ngModel);
                  /*alert($element.val());
                  $elementVar.detach();
                  $(this).append($elementVar);
                  $(this).trigger("change");*/
              });

              function cambiando(old, nuevo){
                //  console.log('cambiando',old, nuevo,'scope', scope)
                if (!nuevo) {
                  return true;
                }
                if(scope.ngModel==""){
                  $element.trigger('change.select2');
                  // console.log('cambiando 0')
                }else{
                  var texto = $element.find("option:selected").text();
                  if(!texto && scope.ngModel && $attrs.campos){
                    if(Array.isArray(ngModel.$viewValue)){
                      for(var cont=0;cont<ngModel.$viewValue.length;cont++){
                        if(ngModel.$viewValue[cont]!=0){
                          var $newOption = $("<option selected='selected'></option>").val(ngModel.$viewValue[cont]).text("Cargando..");
                          $element.append($newOption).trigger('change.select2');
                          // console.log('cambiando 1')
                        }
                      }
                    }else{
                        if(ngModel.$viewValue!=0){
                          var $newOption = $("<option selected='selected'></option>").val(ngModel.$viewValue).text("Cargando..");
                          $element.append($newOption).trigger('change.select2');
                          // console.log('cambiando2',$newOption,ngModel.$viewValue)
                        }
                    }
                    if(scope.ngModel!=0){
                      $.get('/backend/hojafabricacion/getvalueselect2lotes',{ ignoreLoadingBar: true, campo:$attrs.campos,nodetype:$attrs.nodetype,value:scope.ngModel,diasacaducar:$attrs.diasacaducar,extraparams:scope.extraparams},function(data){
                        // console.log('getvalueselect2lotes',data);
                        for(var cont=0;cont<data.length;cont++){
                            $element.find("option[value='"+data[cont].id+"']").text(data[cont].lote);
                        }    
                        $element.select2(options).trigger('change.select2');
                        // console.log('cambiando 22')
                        // if (data?.length <= 0) {
                        //   // console.log('cambiando Vacio')
                        //   ngModel.$setViewValue("");
                        // } else {
                        //   if (data[0].id != ngModel.$viewValue) {
                        //     // console.log('cambiando id',data[0].id, '!=', ngModel.$viewValue)
                        //     ngModel.$setViewValue(data[0].id);
                        //   }
                          
                        // }
                      },"json");
                    }
                  }else{
                    $element.trigger('change.select2');
                    // console.log('cambiando 3')

                  }
                  //$element.trigger('change.select2');
                }
              }
              scope.$watch('ngModel', cambiando, true);

            });
          }
        }
    }
})();